import { createSlice } from '@reduxjs/toolkit'

import { fromStringsToDateTime } from '../hooks/utils-functions'

const initialState = {
  availableCategorie: ['Tutte'],
  availableGironi: ['Tutti'],
  availablePeriodi: ['Tutte'],
  availableRitardi: ['Tutti'],
  availableTessere: ['Tutti'],
}

const selectionSlice = createSlice({
  name: 'selection',
  initialState,
  reducers: {
    resetSelection: () => initialState,
    setAvailableStagioni(state, action) {
      state.availableStagioni = action.payload
    },
    setSelectedStagione(state, action) {
      state.selectedStagione = action.payload
    },
    setAvailableCampionati(state, action) {
      state.availableCampionati = action.payload
    },
    setSelectedCampionato(state, action) {
      const { selectedCampionato, campionati } = action.payload || {}
      const c = campionati?.find(c => c.codice === selectedCampionato)
      const d = fromStringsToDateTime(c?.termineSpostamentiGratuiti, '23:59')

      state.selectedCampionato = selectedCampionato
      state.selectedCampionatoIscrizioniAperte = !!c?.iscrizioniAperte
      state.selectedCampionatoGironiPubblicati = !!c?.gironiPubblicati
      state.selectedCampionatoCalendariPubblicati = !!c?.calendariPubblicati
      state.selectedCampionatoSpostamentiGratuiti = d > new Date()
      state.selectedCampionatoChiuso = !!c?.campionatoChiuso
    },
    setAvailableCategorie(state, action) {
      state.availableCategorie = [
        ...initialState.availableCategorie,
        ...action.payload,
      ]
    },
    setSelectedCategoria(state, action) {
      state.selectedCategoria = action.payload
    },
    setAvailableGironi(state, action) {
      state.availableGironi = [
        ...initialState.availableGironi,
        ...action.payload,
      ]
    },
    setSelectedGirone(state, action) {
      state.selectedGirone = action.payload
    },
    setAvailableTeams(state, action) {
      state.availableTeams = action.payload
    },
    setSelectedTeam(state, action) {
      state.selectedTeam = action.payload
    },
    setSelectedTeams(state, action) {
      state.selectedTeams = action.payload
    },
    setAvailableNumeriGara(state, action) {
      state.availableNumeriGara = action.payload
    },
    setSelectedNumeroGara(state, action) {
      state.selectedNumeroGara = action.payload
    },
    setAvailableProvvedimenti(state, action) {
      state.availableProvvedimenti = action.payload
    },
    setSelectedProvvedimento(state, action) {
      state.selectedProvvedimento = action.payload
    },
    setAvailableArbitraggi(state, action) {
      state.availableArbitraggi = action.payload
    },
    setSelectedArbitraggio(state, action) {
      state.selectedArbitraggio = action.payload
    },
    setAvailablePeriodi(state, action) {
      state.availablePeriodi = [
        ...initialState.availablePeriodi,
        ...action.payload,
      ]
    },
    setSelectedPeriodo(state, action) {
      state.selectedPeriodo = action.payload
    },
    setAvailableRitardi(state, action) {
      state.availableRitardi = [
        ...initialState.availableRitardi,
        ...action.payload,
      ]
    },
    setSelectedRitardo(state, action) {
      state.selectedRitardo = action.payload
    },
    setAvailableTessere(state, action) {
      state.availableTessere = [
        ...initialState.availableTessere,
        ...action.payload,
      ]
    },
    setSelectedTessera(state, action) {
      state.selectedTessera = action.payload
    },
    setSelectedArbitro(state, action) {
      state.selectedArbitro = action.payload
    },
    setSelectedSocieta(state, action) {
      state.selectedSocieta = action.payload
    },
    setSelectedNumeriGara(state, action) {
      state.selectedNumeriGara = action.payload
    },
  },
})

export const {
  resetSelection,
  setAvailableStagioni,
  setSelectedStagione,
  setAvailableCampionati,
  setSelectedCampionato,
  setAvailableCategorie,
  setSelectedCategoria,
  setAvailableGironi,
  setSelectedGirone,
  setAvailableTeams,
  setSelectedTeam,
  setSelectedTeams,
  setAvailableNumeriGara,
  setSelectedNumeroGara,
  setAvailableProvvedimenti,
  setSelectedProvvedimento,
  setAvailableArbitraggi,
  setSelectedArbitraggio,
  setAvailablePeriodi,
  setSelectedPeriodo,
  setAvailableRitardi,
  setSelectedRitardo,
  setAvailableTessere,
  setSelectedTessera,
  setSelectedArbitro,
  setSelectedSocieta,
  setSelectedNumeriGara,
} = selectionSlice.actions

export default selectionSlice.reducer
